import { useOktaAuth } from '@okta/okta-react';
import { useEffect, useState } from 'react';

import { UseAuthValue } from '../types';

const useAuth = (): UseAuthValue => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | undefined>();
  const [accessToken, setAccessToken] = useState<string | undefined>();
  const { authState: oktaAuthState, oktaAuth } = useOktaAuth();

  const isAuth = oktaAuthState?.isAuthenticated;

  useEffect(() => {
    if (oktaAuthState === null) return;
    setIsAuthenticated(isAuth);

    const accessToken = oktaAuth?.getAccessToken();

    if (accessToken) {
      setAccessToken(accessToken);
    }
  }, [oktaAuthState, oktaAuth]);

  const authService = oktaAuth;

  return {
    accessToken,
    authService,
    idToken: oktaAuthState?.idToken,
    isAuthenticated,
  };
};

export default useAuth;
